/* =================================

Screen 1 ICE Table

===================================*/
export const getICETransactions = [
  {
    data: "Same as manual Adjs.",
  },
];

/* =================================

View Workings

===================================*/
export const getICEWorkingsDropdown = {
  transactions: [
    "Sales Invoice",
    "Sales Return",
    "Purchase Bill",
    "Purchase Return",
    "Bank Deposit",
    "Bank Withdrawal",
    "Cash Receipt",
    "Cash Payment",
    "Journal Entry",
    "Fund Transfer",
  ],
  outstandingBalance: [
    "Purchase Order",
    "Purchase Invoice",
    "Purchase Return",
    "Vendor Payment",
    "Advance to Vendor",
    "Expense Claim",
    "Utility Bill",
    "Rent Payment",
    "Goods Receipt Note",
    "Import Charges",
  ],
};

export const getICEWorkings = {
  transactionsOptions: [
    // {
    //   transA: ["Sales Invoice"],
    //   transB: ["Sales Return","Purchase Bill"],
    // },
    // {
    //   transA: ["Sales Invoice", "Purchase Bill"],
    //   transB: ["Sales Return"],
    // },
  ],
  outstandingBalanceOptions: [
    // {
    //   transA: ["Sales Invoice", "Purchase Bill"],
    //   transB: ["Sales Return"],
    // },
    // {
    //   transA: ["Sales Invoice"],
    //   transB: ["Sales Return",, "Purchase Bill"],
    // },
    // {
    //   transA: ["Sales Invoice", "Purchase Bill"],
    //   transB: ["Sales Return"],
    // },
  ],
  
  transactions: [
    {
      tranA: ["Bank Deposit", "Sales Invoice"],
      tranAamount: 3200,
      tranB: ["Bank Deposit", "Cash Receipt", "Sales Invoice"],
      tranBamount: 3200,
      reconciliation: 3200,
      difference: 0
    },
    {
      tranA: ["Purchase Bill", "Sales Invoice"],
      tranAamount: 4500,
      tranB: ["Purchase Bill", "Cash Payment"],
      tranBamount: 4500,
      reconciliation: 4500,
      difference: 0
    },
    {
      tranA: ["Sales Return", "Bank Withdrawal"],
      tranAamount: 500,
      tranB: ["Sales Return"],
      tranBamount: 500,
      reconciliation: 500,
      difference: 0
    },
    {
      tranA: ["Purchase Return", "Fund Transfer"],
      tranAamount: 800,
      tranB: ["Fund Transfer", "Journal Entry"],
      tranBamount: 800,
      reconciliation: 800,
      difference: 0
    },
    {
      tranA: ["Cash Payment", "Sales Invoice", "Purchase Return"],
      tranAamount: 1200,
      tranB: ["Sales Invoice", "Cash Receipt"],
      tranBamount: 1200,
      reconciliation: 1200,
      difference: 0
    },
    {
      tranA: ["Bank Deposit"],
      tranAamount: 2000,
      tranB: ["Cash Receipt", "Bank Withdrawal"],
      tranBamount: 2000,
      reconciliation: 2000,
      difference: 0
    },
    {
      tranA: ["Vendor Payment", "Fund Transfer"],
      tranAamount: 2200,
      tranB: ["Fund Transfer", "Journal Entry", "Vendor Payment"],
      tranBamount: 2200,
      reconciliation: 2200,
      difference: 0
    },
    {
      tranA: ["Sales Invoice", "Purchase Bill", "Cash Payment"],
      tranAamount: 5000,
      tranB: ["Purchase Bill", "Sales Invoice"],
      tranBamount: 5000,
      reconciliation: 5000,
      difference: 0
    },
    {
      tranA: ["Cash Receipt", "Purchase Return"],
      tranAamount: 800,
      tranB: ["Cash Payment"],
      tranBamount: 800,
      reconciliation: 800,
      difference: 0
    },
    {
      tranA: ["Bank Withdrawal", "Purchase Return", "Fund Transfer"],
      tranAamount: 1300,
      tranB: ["Purchase Return", "Fund Transfer"],
      tranBamount: 1300,
      reconciliation: 1300,
      difference: 0
    }
  ],
  outstandingBalance: [
    {
      tranA: ["Purchase Order", "Purchase Invoice"],
      tranAamount: 1500,
      tranB: ["Purchase Invoice"],
      tranBamount: 1500,
      reconciliation: 1500,
      difference: 0
    },
    {
      tranA: ["Purchase Return", "Vendor Payment"],
      tranAamount: 600,
      tranB: ["Vendor Payment"],
      tranBamount: 600,
      reconciliation: 600,
      difference: 0
    },
    {
      tranA: ["Advance to Vendor", "Expense Claim"],
      tranAamount: 500,
      tranB: ["Expense Claim", "Vendor Payment"],
      tranBamount: 500,
      reconciliation: 500,
      difference: 0
    },
    {
      tranA: ["Utility Bill", "Goods Receipt Note"],
      tranAamount: 200,
      tranB: ["Utility Bill"],
      tranBamount: 200,
      reconciliation: 200,
      difference: 0
    },
    {
      tranA: ["Rent Payment", "Import Charges", "Expense Claim"],
      tranAamount: 1000,
      tranB: ["Import Charges", "Rent Payment"],
      tranBamount: 1000,
      reconciliation: 1000,
      difference: 0
    },
    {
      tranA: ["Purchase Invoice", "Goods Receipt Note", "Utility Bill"],
      tranAamount: 2500,
      tranB: ["Goods Receipt Note", "Utility Bill"],
      tranBamount: 2500,
      reconciliation: 2500,
      difference: 0
    },
    {
      tranA: ["Vendor Payment", "Advance to Vendor"],
      tranAamount: 1200,
      tranB: ["Vendor Payment", "Advance to Vendor"],
      tranBamount: 1200,
      reconciliation: 1200,
      difference: 0
    },
    {
      tranA: ["Expense Claim", "Purchase Invoice"],
      tranAamount: 900,
      tranB: ["Expense Claim"],
      tranBamount: 900,
      reconciliation: 900,
      difference: 0
    },
    {
      tranA: ["Sales Invoice", "Bank Deposit"],
      tranAamount: 2000,
      tranB: ["Sales Invoice"],
      tranBamount: 2000,
      reconciliation: 2000,
      difference: 0
    },
    {
      "tranA": ["Cash Payment", "Sales Return", "Rent Payment"],
      "tranAamount": 1500,
      "tranB": ["Sales Return", "Cash Payment"],
      "tranBamount": 1500,
      "reconciliation": 1500,
      "difference": 0
    }
  ]

};

export const transactionOutBalancesPayload = {
  transactions: [
    {
      transA: ["Sales Invoice", "Purchase Bill"],
      transB: ["Sales Return", "Purchase Bill", "Purchase Bill"],
    },
    {
      transA: ["Sales Invoice", "Purchase Bill"],
      transB: ["Sales Return", "Purchase Bill", "Purchase Bill"],
    },
  ],
  outstandingBalance: [
    {
      transA: ["Sales Invoice", "Purchase Bill"],
      transB: ["Sales Return", "Purchase Bill", "Purchase Bill"],
    },
    {
      transA: ["Sales Invoice", "Purchase Bill"],
      transB: ["Sales Return", "Purchase Bill", "Purchase Bill"],
    },
    {
      transA: ["Sales Invoice", "Purchase Bill"],
      transB: ["Sales Return", "Purchase Bill", "Purchase Bill"],
    },
  ],
};

/* =================================

Perform Reconciliation

===================================*/

export const getCompaniesReconciliationData = [
  {
    "companyA": "TCS",
    "companyB": "Accenture",
    "reconciliationTable": [
      {
        "companyA": [
          { "particular": "Revenue", "amount": 12000 },
          { "particular": "Other Income", "amount": 2000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 5000 },
          { "particular": "Returns", "amount": 2000 }
        ],
        "difference": 5000
      },
      {
        "companyA": [{ "particular": "Revenue", "amount": 6000 }],
        "companyB": [
          { "particular": "Sales", "amount": 2500 },
          { "particular": "Discounts", "amount": 1500 }
        ],
        "difference": 2000
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 9000 },
          { "particular": "Tax", "amount": 1000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 3000 },
          { "particular": "Returns", "amount": 3000 },
          { "particular": "Discounts", "amount": 3000 }
        ],
        "difference": 0
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 8000 },
          { "particular": "Other Income", "amount": 500 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 4000 },
          { "particular": "Returns", "amount": 1000 },
          { "particular": "Discounts", "amount": 500 }
        ],
        "difference": 2500
      }
    ]
  },
  {
    "companyA": "Cognizant",
    "companyB": "Wipro",
    "reconciliationTable": [
      {
        "companyA": [
          { "particular": "Revenue", "amount": 13000 },
          { "particular": "Other Income", "amount": 1000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 6000 },
          { "particular": "Discounts", "amount": 2000 }
        ],
        "difference": 5000
      },
      {
        "companyA": [{ "particular": "Revenue", "amount": 7000 }],
        "companyB": [
          { "particular": "Sales", "amount": 3500 },
          { "particular": "Returns", "amount": 1000 }
        ],
        "difference": 2500
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 10000 },
          { "particular": "Other Income", "amount": 500 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 5000 },
          { "particular": "Returns", "amount": 2000 },
          { "particular": "Discounts", "amount": 1000 }
        ],
        "difference": 2000
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 12000 },
          { "particular": "Tax", "amount": 1000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 7000 },
          { "particular": "Discounts", "amount": 4000 },
          { "particular": "Returns", "amount": 2000 }
        ],
        "difference": 2000
      }
    ]
  },
  {
    "companyA": "Capgemini",
    "companyB": "HCL Technologies",
    "reconciliationTable": [
      {
        "companyA": [
          { "particular": "Revenue", "amount": 14000 },
          { "particular": "Other Income", "amount": 500 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 4500 },
          { "particular": "Returns", "amount": 500 }
        ],
        "difference": 3000
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 8000 },
          { "particular": "Tax", "amount": 1000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 3500 },
          { "particular": "Discounts", "amount": 500 }
        ],
        "difference": 4000
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 9500 },
          { "particular": "Other Income", "amount": 1000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 4750 },
          { "particular": "Returns", "amount": 2000 }
        ],
        "difference": 2750
      },
      {
        "companyA": [
          { "particular": "Revenue", "amount": 13000 },
          { "particular": "Tax", "amount": 2000 }
        ],
        "companyB": [
          { "particular": "Sales", "amount": 7000 },
          { "particular": "Returns", "amount": 1000 },
          { "particular": "Discounts", "amount": 2000 }
        ],
        "difference": 1000
      }
    ]
  }
]



/* =================================

View Reconciliation

===================================*/

export const viewReconciliation = {
  companyA: {
    title: "Volkswagen Automobiles LLC",
    transactionAndBalancesList: [
      "Sale of Goods",
      "Interest income",
      "Other operationg revenue",
    ],
    transactionAndBalancesAmounts: [
      {
        invoiceNumber: "INV-1003",
        invoiceDate: "11 July 2025",
        invoiceAmount: 15300,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1007",
        invoiceDate: "21 July 2025",
        invoiceAmount: 8750,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1009",
        invoiceDate: "26 July 2025",
        invoiceAmount: 21500,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1012",
        invoiceDate: "3 August 2025",
        invoiceAmount: 17800,
        status: "Partial Match",
      },
      {
        invoiceNumber: "INV-1014",
        invoiceDate: "10 August 2025",
        invoiceAmount: 11800,
        status: "Partial Match 2",
      },
      {
        invoiceNumber: "INV-1002",
        invoiceDate: "9 July 2025",
        invoiceAmount: 8420,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1006",
        invoiceDate: "18 July 2025",
        invoiceAmount: 10200,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1010",
        invoiceDate: "29 July 2025",
        invoiceAmount: 9650,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1015",
        invoiceDate: "10 August 2025",
        invoiceAmount: 12450,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1004",
        invoiceDate: "14 July 2025",
        invoiceAmount: 6780,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1008",
        invoiceDate: "23 July 2025",
        invoiceAmount: 14780,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1013",
        invoiceDate: "5 August 2025",
        invoiceAmount: 11290,
        status: "No Match",
      },
    ],
  },
  companyB: {
    title: "Lendio Corporation Ltd",
    transactionAndBalancesList: [
      "Sale of Goods",
      "Interest income",
      "Other operationg revenue",
    ],
    transactionAndBalancesAmounts: [
      {
        invoiceNumber: "INV-1003",
        invoiceDate: "11 July 2025",
        invoiceAmount: 15300,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1007",
        invoiceDate: "21 July 2025",
        invoiceAmount: 8750,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1009",
        invoiceDate: "26 July 2025",
        invoiceAmount: 21500,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1012",
        invoiceDate: "3 August 2025",
        invoiceAmount: 17800,
        status: "Full Match",
      },
      {
        invoiceNumber: "INV-1014",
        invoiceDate: "10 August 2025",
        invoiceAmount: 11800,
        status: "Partial Match",
      },
      {
        invoiceNumber: "INV-1002",
        invoiceDate: "9 July 2025",
        invoiceAmount: 8420,
        status: "Partial Match",
      },
      {
        invoiceNumber: "INV-1006",
        invoiceDate: "18 July 2025",
        invoiceAmount: 10200,
        status: "Partial Match",
      },
      {
        invoiceNumber: "INV-1010",
        invoiceDate: "29 July 2025",
        invoiceAmount: 9650,
        status: "Partial Match 2",
      },
      {
        invoiceNumber: "INV-1015",
        invoiceDate: "10 August 2025",
        invoiceAmount: 12450,
        status: "Partial Match 2",
      },
      {
        invoiceNumber: "INV-1004",
        invoiceDate: "14 July 2025",
        invoiceAmount: 6780,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1008",
        invoiceDate: "23 July 2025",
        invoiceAmount: 14780,
        status: "No Match",
      },
      {
        invoiceNumber: "INV-1013",
        invoiceDate: "5 August 2025",
        invoiceAmount: 11290,
        status: "No Match",
      },
    ],
  },
};
